<template>
  <div class="contaier">
    <head-page></head-page>
    <div class="top-banner">
      <picture class="picture" style="" data-v-5052e3a5="" data-v-893d3ba0=""
        ><source
          srcset="./assets/img/icaur_V27_1.jpg"
          media="(min-width: 992px)"
          data-v-893d3ba0="" />
        <source
          srcset="./assets/img/icaur_V27_2.jpg"
          media="(min-width: 576px)"
          data-v-893d3ba0="" />
        <img src="./assets/img/icaur_V27_3.jpg" loading="lazy" alt="" data-v-893d3ba0=""
      /></picture>
    </div>
    <!-- <div @click="testFn">test</div> -->
    <form-page ref="formPageRef"></form-page>
    <footer-page></footer-page>
  </div>
</template>

<script>
// import { carouselList, textList, imgsrc } from '@/assets/js/static.js'

import FormPage from "@/components/FormPage.vue";
import HeadPage from "@/components/HeadPage.vue";
import FooterPage from "@/components/FooterPage.vue";
export default {
  name: "HomeView",
  components: {
    HeadPage,
    FormPage,
    FooterPage,
  },
  data() {
    return {
      // imageUrl: require("@/assets/img/list/7.jpg"),
      // imgsrc,
      // carouselList,
      // textList,
      speak: "中文",
    };
  },
  computed: {},
  mounted() {
    //可能是router没准备好，用this.$router.onReady解决
    // this.$router.onReady(() => {
    //   let query = this.$route.query;
    //   console.log("onReady :>>query ", query);
    // });

    console.log("(this.$i18n.locale :>>11 ", this.$i18n.locale);
    console.log("this.$route.query.lang :>> ", this.$route.query);

    if (this.$route?.query?.lang) {
      console.log("存在 :>> ");
      if (this.$route.query.lang === "en") {
        this.$i18n.locale = "en";
        this.$refs.formPageRef.changeLanguage("zh");
        window.sessionStorage.setItem("sessionLang", "en");
      } else {
        this.$i18n.locale = "zh";
        this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
          console.log("data :>>00 ", data);
        });
        window.sessionStorage.setItem("sessionLang", "zh");
      }
    } else {
      let lang = window.sessionStorage.getItem("sessionLang") || "zh";
      console.log("不存在 :>> -sessionStorage", lang);
      if (lang === "zh") {
        console.log("进入11111", lang);
        this.$router.push({ path: "/survey", query: { lang: "zh" } }).catch((data) => {
          console.log("data :>> 1", data);
        });
        this.$i18n.locale = "zh";
      } else {
        console.log("进入22222", lang);
        this.$router.push({ path: "/survey", query: { lang: "en" } }).catch((data) => {
          console.log("data :>>2 ", data);
        });
        this.$i18n.locale = "en";
        this.$refs.formPageRef.changeLanguage("zh");
      }
    }
  },
  methods: {
    testFn() {
      console.log("this.$i18n.locale :>> ", this.$i18n.locale);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "element-ui/lib/theme-chalk/display.css";
.img {
  object-fit: cover;
}
.contaier {
  .top-banner {
    width: 100%;
    height: 80vh;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
